import { TsDOM as q } from '@/scripts/core/TsDOM'
import { QuizBundleRecommendation } from '@/scripts/sections/quiz-bundle-recommendation'
import { QuizOfferCountdown } from '@/scripts/sections/quiz-offer-countdown'

q.safeDefineElement(QuizBundleRecommendation)
q.safeDefineElement(QuizOfferCountdown)
